import axiosInstance from "../../axios";
import AXIOS_ROUTES from "../../axios/routes";
import { IFetchParams } from "../../interfaces/base";
import {
  ICopyWorkoutInProgramPayload,
  ICreateTrainingProgramPayload,
  ICreateWorkoutInProgramPayload,
  IEnableWorkoutInProgramPayload,
  IMoveWorkoutInProgramPayload,
  IRemoveWorkoutFromProgramPayload,
  IUpdateTrainingProgramPayload,
} from "../../interfaces/store/training-program-interface";

export const getTrainingProgramApi = async (id: string) => {
  return await axiosInstance.get(
    `${AXIOS_ROUTES.trainingPrograms.getTrainingProgram}?trainingProgramId=${id}`
  );
};

export const createTrainingProgramApi = async (
  data: ICreateTrainingProgramPayload
) => {
  return await axiosInstance.post(
    AXIOS_ROUTES.trainingPrograms.createTrainingProgram,
    data.trainingProgram
  );
};

export const updateTrainingProgramApi = async ({
  trainingProgramId,
  trainingProgram,
}: IUpdateTrainingProgramPayload) => {
  return await axiosInstance.put(
    `${AXIOS_ROUTES.trainingPrograms.updateTrainingProgram}?trainingProgramId=${trainingProgramId}`,
    trainingProgram
  );
};

export const deleteTrainingProgramApi = async (trainingProgramId: string) => {
  return await axiosInstance.delete(
    `${AXIOS_ROUTES.trainingPrograms.deleteTrainingProgram}?trainingProgramId=${trainingProgramId}`
  );
};

export const searchTrainingProgramsApi = async (data: any) => {
  return await axiosInstance.post(AXIOS_ROUTES.trainingPrograms.search, data);
};

export const addWorkoutToTrainingProgramApi = async ({
  trainingProgramId,
  index,
  workout,
}: ICreateWorkoutInProgramPayload) => {
  return await axiosInstance.put(
    `${AXIOS_ROUTES.trainingPrograms.addWorkout}?trainingProgramId=${trainingProgramId}&index=${index}`,
    workout
  );
};

export const removeWorkoutFromProgramApi = async ({
  trainingProgramId,
  workoutId,
}: IRemoveWorkoutFromProgramPayload) => {
  return await axiosInstance.delete(
    `${AXIOS_ROUTES.trainingPrograms.removeWorkout}?trainingProgramId=${trainingProgramId}&workoutId=${workoutId}`
  );
};

export const enableWorkoutInProgramApi = async (
  data: IEnableWorkoutInProgramPayload
) => {
  return await axiosInstance.put(
    `${AXIOS_ROUTES.trainingPrograms.enableWorkout}`,
    data
  );
};

export const disableWorkoutInProgramApi = async (
  data: IEnableWorkoutInProgramPayload
) => {
  return await axiosInstance.put(
    `${AXIOS_ROUTES.trainingPrograms.disableWorkout}`,
    data
  );
};

export const moveWorkoutInProgramApi = async (
  data: IMoveWorkoutInProgramPayload
) => {
  return await axiosInstance.put(
    `${AXIOS_ROUTES.trainingPrograms.moveWorkout}`,
    data
  );
};

export const getActiveUsersApi = async (
  trainingProgramId: string,
  skip: number,
  limit: number
) => {
  return await axiosInstance.get(
    `${AXIOS_ROUTES.trainingPrograms.getActiveUsers}?trainingProgramId=${trainingProgramId}&skip=${skip}&limit=${limit}`
  );
};

export const copyWorkoutInProgramApi = async ({
  trainingProgramId,
  index,
  workoutId,
}: ICopyWorkoutInProgramPayload) => {
  return await axiosInstance.post(
    `${AXIOS_ROUTES.trainingPrograms.copyWorkout}?workoutId=${workoutId}`,
    { index, trainingProgramId }
  );
};

export const getGroupsApi = async (data: IFetchParams) => {
  return await axiosInstance.post(
    AXIOS_ROUTES.trainingPrograms.getGroups,
    data
  );
};
